export enum EditBranchTab {
  INFOS = 'infos',
  WHITE_LABEL = 'whiteLabel',
}
